export enum AnswerTypeEnum {
    calculated = 'calculated'
}
